(() => {
  const roots = new WeakSet();
  function mount(root) {
    if (roots.has(root)) return;
    const ui = root.querySelector('[data-dv-quiz-ui]');
    if (!ui) return;
    roots.add(root);
    const steps = [...ui.querySelectorAll('.dv-quiz-step')];
    const results = [...ui.querySelectorAll('.dv-quiz-result')];
    const progress = ui.querySelector('[data-dv-quiz-progress]');
    const progressBar = ui.querySelector('[data-dv-quiz-progress-bar]');
    const back = ui.querySelector('[data-dv-quiz-back]');
    const answers = [];
    let current = 0;

    function show(focus = false) {
      steps.forEach((step, index) => {
        step.hidden = index !== current;
        step.querySelectorAll('[data-choice]').forEach(button => {
          button.setAttribute('aria-pressed', String(answers[index] === button));
        });
      });
      results.forEach(result => { result.hidden = true; });
      let heading;
      if (current < steps.length) {
        progress.textContent = `Pregunta ${current + 1} de ${steps.length}`;
        progressBar.value = current + 1;
        heading = steps[current].querySelector('legend');
      } else {
        const capsuleScore = answers.filter(button => button.dataset.choice === 'A').length;
        const key = capsuleScore >= answers.length - capsuleScore ? 'A' : 'B';
        const result = ui.querySelector(`#dv-quiz-res-${key}`);
        result.hidden = false;
        progress.textContent = 'Tu recomendación está lista';
        progressBar.value = steps.length;
        heading = result.querySelector('h3');
      }
      back.hidden = current === 0;
      if (focus) heading?.focus({ preventScroll: true });
    }

    ui.addEventListener('click', event => {
      const choice = event.target.closest('[data-choice]');
      if (choice && steps[current]?.contains(choice)) {
        answers[current] = choice;
        answers.length = current + 1;
        current += 1;
        show(true);
        return;
      }
      if (event.target.closest('[data-dv-quiz-back]') && current > 0) {
        current -= 1;
        show(true);
      }
      if (event.target.closest('[data-dv-quiz-reset]')) {
        answers.length = 0;
        current = 0;
        show(true);
      }
    });
    root.querySelector('[data-dv-quiz-fallback]').hidden = true;
    ui.hidden = false;
    show();

    const reveal = [...root.querySelectorAll('.dv-reveal')];
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal.forEach(element => element.classList.add('is-inview'));
    } else {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      reveal.forEach(element => observer.observe(element));
      root.classList.add('dv-home-motion-ready');
    }
  }
  const scan = () => document.querySelectorAll('[data-dv-home]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
